import type React from "react";

interface TemplatePreviewIconProps {
  className?: string;
  isSelected?: boolean;
}

export const TemplateBarChartIcon01: React.FC<TemplatePreviewIconProps> = ({ className, isSelected }) => {
  // Selected: purple colors (#D6BBFB, #9E77ED, #6941C6)
  // Unselected: gray colors (#E9EAEB, #D5D7DA, #A4A7AE)
  const colors = isSelected
    ? { light: "#D6BBFB", medium: "#9E77ED", dark: "#6941C6" }
    : { light: "#E9EAEB", medium: "#D5D7DA", dark: "#A4A7AE" };

  return (
    <svg
      width="122"
      height="118"
      viewBox="0 0 122 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_template)">
        <g clipPath="url(#clip1_template)">
          <path d="M8 48H32V118H8V48Z" fill={colors.light} />
          <path d="M8 68.4167H32V118H8V68.4167Z" fill={colors.medium} />
          <path d="M8 91.75H32V118H8V91.75Z" fill={colors.dark} />
        </g>
        <g clipPath="url(#clip2_template)">
          <path d="M35.5 24H59.5V118H35.5V24Z" fill={colors.light} />
          <path d="M35.5 51.4167H59.5V118H35.5V51.4167Z" fill={colors.medium} />
          <path d="M35.5 82.75H59.5V118H35.5V82.75Z" fill={colors.dark} />
        </g>
        <g clipPath="url(#clip3_template)">
          <path d="M63 48H87V118H63V48Z" fill={colors.light} />
          <path d="M63 68.4167H87V118H63V68.4167Z" fill={colors.medium} />
          <path d="M63 91.75H87V118H63V91.75Z" fill={colors.dark} />
        </g>
        <g clipPath="url(#clip4_template)">
          <path d="M90.5 48H114.5V118H90.5V48Z" fill={colors.light} />
          <path d="M90.5 68.4167H114.5V118H90.5V68.4167Z" fill={colors.medium} />
          <path d="M90.5 91.75H114.5V118H90.5V91.75Z" fill={colors.dark} />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_template">
          <rect width="122" height="118" fill="white" />
        </clipPath>
        <clipPath id="clip1_template">
          <path d="M8 52C8 49.7909 9.79086 48 12 48H28C30.2091 48 32 49.7909 32 52V118H8V52Z" fill="white" />
        </clipPath>
        <clipPath id="clip2_template">
          <path
            d="M35.5 28C35.5 25.7909 37.2909 24 39.5 24H55.5C57.7091 24 59.5 25.7909 59.5 28V118H35.5V28Z"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip3_template">
          <path d="M63 52C63 49.7909 64.7909 48 67 48H83C85.2091 48 87 49.7909 87 52V118H63V52Z" fill="white" />
        </clipPath>
        <clipPath id="clip4_template">
          <path
            d="M90.5 52C90.5 49.7909 92.2909 48 94.5 48H110.5C112.709 48 114.5 49.7909 114.5 52V118H90.5V52Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
